import { StorageName } from '@/constant/enum';
import { RouterName } from '@/constant/router_name';
import { history } from '@umijs/max';
import { debounce } from 'lodash-es';

export const jumpLoginPage = debounce(() => {
  localStorage.removeItem(StorageName.SessionKey);
  history.replace(RouterName.Login);
});
